/**
 * Salutation locale (Bonjour / Bonsoir) + prénom / nom d’affichage du membre.
 */

/** À partir de 18h (heure locale du navigateur) → Bonsoir. */
export function isEveningGreeting(now = new Date()) {
  return Number(now.getHours()) >= 18;
}

function isGenericName(s, genericLabel = '') {
  const v = String(s || '').trim().toLowerCase();
  const generic = String(genericLabel || '').trim().toLowerCase();
  return (
    !v ||
    v === generic ||
    v === 'membre' ||
    v === 'member' ||
    v === 'user' ||
    v === 'sans nom' ||
    v === 'no name' ||
    v === 'inconnu' ||
    v === 'anonymous'
  );
}

function pickFirstUsefulToken(raw) {
  const s = String(raw || '').trim();
  if (!s) return '';
  if (s.includes(',')) {
    const parts = s.split(',').map((p) => p.trim()).filter(Boolean);
    // « Nom, Prénom » → prénom
    if (parts.length >= 2 && parts[1]) return parts[1];
  }
  return s;
}

/**
 * Extrait un libellé affichable depuis un objet profil / user / stats.
 * `preferFirst` : pour salutation, privilégie le prénom seul.
 */
export function extractDisplayNameFromSource(source, { preferFirst = false } = {}) {
  if (!source || typeof source !== 'object') return '';

  const profile = source.metadata?.profile || source.profile || {};
  const first = String(
    source.first_name || source.given_name || profile.first_name || profile.given_name || ''
  ).trim();
  if (preferFirst && first && !isGenericName(first)) return first;

  const middle = String(source.middle_name || profile.middle_name || '').trim();
  const last = String(source.last_name || source.family_name || profile.last_name || '').trim();
  const composed = [first, middle, last].filter(Boolean).join(' ');
  if (composed) return preferFirst ? first || composed.split(/\s+/)[0] || composed : composed;

  const full = String(
    source.member_name ||
      source.full_name ||
      source.display_name ||
      source.preferred_name ||
      source.name ||
      profile.full_name ||
      profile.name ||
      ''
  ).trim();
  if (!full) return '';
  if (preferFirst) {
    const token = pickFirstUsefulToken(full);
    return token.split(/\s+/)[0] || token;
  }
  return full;
}

/**
 * Nom pour la salutation. `sources` : user, people, personalStats, …
 * Prénom privilégié ; évite « Membre ».
 */
export function resolveGreetingMemberName(sources, genericLabel = '') {
  const list = Array.isArray(sources) ? sources : [sources];
  for (const src of list) {
    const extracted = extractDisplayNameFromSource(src, { preferFirst: true });
    if (!isGenericName(extracted, genericLabel)) return extracted;
  }
  return String(genericLabel || '').trim() || 'Membre';
}

export function memberGreetingI18nKey(now = new Date()) {
  return isEveningGreeting(now) ? 'memberPortal.greetingEvening' : 'memberPortal.greetingMorning';
}
